// eslint-disable-next-line
import React from 'react';
import createReactClass from 'create-react-class';
import _ from 'underscore';
import xtend from 'xtend';
import {
    FormGroup,
    Radio,
    Modal as RBModal
} from 'react-bootstrap';
import Loader from '../../../../common/components/notifications/Loader';
import ModeratorInput from './ModeratorInput';
import config from '../../../../config';

function Chat (opts) {
    return xtend({
        enabled: false,
        chatTypeID: 2,
        isLoginEnabled: false,
        loginPass: null,
        chatTypeHeading: 'Moderated Discussion',
        chatLoginText: 'Please Login to join the discussion',
        chatStandbyText: 'Please Standby for the discussion to begin'
    }, opts);
}

var ChatModal = createReactClass({
    getInitialState: function () {
        return {
            addingMod: false,
            chatSettings: {},
            newMod: null
        };
    },

    updateChatSettings: function (data) {
        this.setState({
            chatSettings: xtend(this.state.chatSettings, data)
        })
    },

    onHeadingChange: function (ev) {
        this.updateChatSettings({ chatTypeHeading: ev.target.value })
    },

    onLoginTextChange: function (ev) {
        this.updateChatSettings({ chatLoginText: ev.target.value })
    },

    onStandbyTextChange: function (ev) {
        this.updateChatSettings({ chatStandbyText: ev.target.value })
    },

    addMod: function (ev) {
        ev.preventDefault();
        this.setState({ addingMod: true });
    },

    getChatData: function () {
        var existingChat = this.props.event.chat;
        existingChat = existingChat ? existingChat : Chat({
            enabled: false
        });
        var chat = xtend(existingChat, this.state.chatSettings);
        return chat;
    },

    chatIsValid: function () {
        var existingChat = this.props.event.chat;
        existingChat = existingChat ? existingChat : Chat({
            enabled: false
        });
        var chat = xtend(existingChat, this.state.chatSettings);

        if (!chat.enabled) {
            return !!existingChat.enabled;
        }

        if (chat.enabled && chat.chatTypeID == '2') {
            return this.getAssignedMods().length > 0;
        }
    },

    removeModerator: function (moderator) {
        // this.props.chatActions.deleteModerator(xtend(mod, {
        //     eventID: this.props.event.eventID
        // }));
        const eventId = this.props.event.eventID
        const clientId = this.props.event.clientID
        this.props.chatActions.deleteModerator({ data: {
            type:'deleteModerator', moderator, eventId, clientId
        }})
    },

    resetPassword: function (mod) {
        this.props.chatActions.resetPassword(xtend(mod, {
            eventID: this.props.event.eventID
        }));
    },

    handleChatSelect: function (ev) {
        var val = ev.target.value;
        var newData = {
            enabled: !(val === 'disabled'),
            chatTypeID: 2
        };
        this.setState({
            chatSettings: xtend(this.state.chatSettings, newData)
        });
    },

    onSubmit: function (ev) {
        ev.preventDefault();
        this.props.onSubmit(this.getChatData(ev));
        const eventId = this.props.event.eventID
        const clientId = this.props.event.clientID
        const settings = this.getChatData(ev)
        settings.isChatEnabled = true
        this.props.chatActions.updateChatSettings({eventId, clientId, settings})
    },

    submitModerator: function (ev) {
        ev.preventDefault();
        const newMod = this.state.newMod
        const eventId = this.props.event.eventID
        const clientId = this.props.event.clientID
        this.props.chatActions.createModerator({ data: {
            type:'createModerator', moderator:newMod, eventId, clientId, chatIsEnabled: !!this.props.event.chat
        }})
        this.setState({ addingMod: false });
    },

    onHide: function (ev) {
        ev.preventDefault();
        this.setState({ addingMod: false, chatSettings: {} });
        this.props.onHide();
    },

    cancelAddModerator: function () {
        this.setState({ addingMod: false });
    },

    getAssignedMods: function () {
        var evID = this.props.event.eventID;
        var modsIndex = this.props.chat.data;
        var assignedMods = (modsIndex[evID] || []);
        return assignedMods;
    },

    onModChange: function (mod) {
        this.setState({
            newMod: mod
        });
    },

    onCancelMod: function (ev) {
        ev.preventDefault();
        this.setState({ addingMod: false });
    },

    render: function () {
        var evID = this.props.event.eventID;
        var loading = _(this.props.requests.chat.resolving).find(r => {
            return r.req.eventID == evID;
        });

        // var adminUrl = ('https://chatadmin.invintus.com?clientID=' +
        var adminUrl = (config.chat.page + 'clientID=' +
            this.props.event.clientID + '&' + 'eventID=' +
            this.props.event.eventID);


        var chatData = null;
        try {
            chatData = this.props.event.chat
        } catch (err) {
            // ok
        }

        return <RBModal
            bsSize="large"
            show={this.props.show}
            onHide={this.props.onHide}
        >
            <RBModal.Header>
                <span className="h4" style={{
                    marginRight: '1em'
                }}>
                    {this.state.addingMod ?
                        'Create moderator' :
                        <span>
                            Chat settings for <em>{this.props.event.title}</em>
                        </span>
                    }
                </span>

                {chatData && chatData.enabled ?
                    <a target="_blank" href={adminUrl}>
                        Login <i className="fa fa-external-link" aria-hidden="true"></i>
                    </a> :
                    null
                }
            </RBModal.Header>

                <RBModal.Body>
                    {modalBody.call(this)}
                </RBModal.Body>

                <RBModal.Footer>
                    {this.state.addingMod ?
                        <div>
                            <button className="btn btn-default"
                                onClick={this.onCancelMod}>
                                Cancel
                            </button>

                            <button className="btn btn-primary"
                                onClick={this.submitModerator}
                                disabled={!ModeratorInput.isValid(
                                    this.state.newMod)}>
                                <i className="far fa-floppy-disk"/> Save moderator
                            </button>
                        </div> :

                        <div>
                            <button className="btn btn-default"
                                onClick={this.onHide}
                            >Cancel</button>

                            <button className="btn btn-primary" onClick={this.onSubmit}
                                disabled={!(this.chatIsValid()) || loading}>
                                <i className="far fa-floppy-disk"/> Save
                            </button>
                        </div>
                    }
                </RBModal.Footer>

        </RBModal>;
    }
});

function modalBody () {
    var self = this;
    var _chat = this.props.event.chat;
    _chat = _chat ? _chat : Chat({
        enabled: false
    });
    var chat = xtend(_chat, this.state.chatSettings);

    var evID = this.props.event.eventID;

    var loading = _(this.props.requests.chat.resolving).find(r => {
        // return r.req.eventID === evID;
        return r && r.req && r.req.eventID === evID || r.req.data && r.req.data.eventId === evID
    });
    if (loading) return <Loader message="" />;
    var showMods = chat.enabled && chat.chatTypeID == 2 &&
        !this.state.addingMod;
    var showTextConfig = chat.enabled && chat.chatTypeID == 2 &&
        !this.state.addingMod;
    // hide moderators that don't have an assigned email
    // this was caused by differences between legacy and v2 chat
    var assignedMods = this.getAssignedMods().filter(mod => !!mod.email)

    return <div>
        <FormGroup>
            <Radio
                checked={!chat.enabled}
                onChange={this.handleChatSelect}
                name="chatTypeID"
                value="disabled"
            >
                None
            </Radio>

            <Radio
                onChange={this.handleChatSelect}
                checked={chat.enabled && chat.chatTypeID == 2}
                name="chatTypeID"
                value="2"
            >
                Moderated chat
            </Radio>
        </FormGroup>

        {showTextConfig ?
            [<FormGroup key={'config0'}>
                <label>Heading text</label>
                <input type="text" className="form-control"
                    name="chatTypeHeading"
                    placeholder="Moderated discussion"
                    value={chat.chatTypeHeading}
                    onChange={this.onHeadingChange}
                />
            </FormGroup>,

            <FormGroup key={'config1'}>
                <label>Login message</label>
                <input type="text" className="form-control"
                    name="chatLoginText"
                    placeholder="Please login to join the discussion"
                    value={chat.chatLoginText}
                    onChange={this.onLoginTextChange}
                />
            </FormGroup>,

            <FormGroup key={'config2'}>
                <label>Standby message</label>
                <input type="text" className="form-control"
                    name="chatStandbyText"
                    placeholder="Please standby for the discussion to begin"
                    value={chat.chatStandbyText}
                    onChange={this.onStandbyTextChange}
                />
            </FormGroup>] :

            null
        }

        {this.state.addingMod ?
            <ModeratorInput onSubmit={this.submitModerator}
                onCancel={this.cancelAddModerator}
                onChange={this.onModChange}
            /> :
            null
        }

        {showMods ?
            <div>
                <label>Moderators</label>
                <ul className="list-unstyled" key={'modslist'}>
                    {assignedMods.map(function (mod, i) {
                        return <li key={i}>

                            <Moderator name={mod.name} email={mod.email}
                                onRemove={function (ev) {
                                    ev.preventDefault();
                                    self.removeModerator(mod);
                                }}
                                onPasswordReset={ev => {
                                    ev.preventDefault();
                                    self.resetPassword(mod);
                                }}
                            />

                        </li>;
                    })}
                </ul>
                <AddModerator onClick={this.addMod} />
            </div> :
            null
        }
    </div>;
}

function AddModerator (props) {
    return <div className="add-mod">
        <button className="btn btn-link" onClick={props.onClick}>
            <i className="fa fa-plus" aria-hidden="true" /> Add moderator
        </button>
    </div>;
}

function Moderator (props) {
    return <div className="chat-moderator">
        <div className="mod-head">
            <em>Moderator</em>
        </div>

        <div className="mod-field">
            <span className="mod-label">Name: </span>
            <span className="mod-value">{props.name}</span>
        </div>

        <div className="mod-field">
            <span className="mod-label">Email: </span>
            <span className="mod-value">{props.email}</span>
        </div>

        <div className="mod-controls">
            {/* <button className="btn btn-warning"
                title="Set a new password and re-send an email invitation"
                onClick={props.onPasswordReset}
            >
                <i className="fa fa-exclamation-triangle" aria-hidden="true"></i> Reset password
            </button> */}

            <button className="btn btn-default"
                onClick={props.onRemove}
            >
                <i className="fa fa-trash-can" aria-hidden="true"></i> Remove
            </button>
        </div>
    </div>;
}


export default ChatModal;
